import { Controller } from '@hotwired/stimulus'

// Discard device-side retry data once a walk has been saved or successfully deleted.
export default class extends Controller {
  static values = { storageKey: String, completed: Boolean }

  connect () {
    if (this.completedValue) this.clear()
  }

  deleted (event) {
    if (event.detail.success) this.clear()
  }

  clear () {
    try {
      window.localStorage.removeItem(this.storageKeyValue)
    } catch (_) {}
  }
}
